module.exports = __webpack_public_path__ + "fonts/55288fc34fa70937faedaba422e9bd86.txt";